export default __webpack_public_path__ + "static/media/logo-icon-co.2620c34c.svg";